import { GrapeIcon } from '#app/components/icons'

export enum ContentTypes {
	CONTENTBLOCK = 'ContentBlock',
	SPACER = 'Spacer',
	IMAGETEXT = 'ImageText',
	PRODUCT = 'Product',
	TASTINGNOTE = 'TastingNote',
	COURSEDATELIST = 'CourseDateList',
}

export enum PostTypes {
	Wine = 'Wine',
	Study = 'Study',
	GrapeVarietals = 'Varietals',
}

export enum ProductTypes {
	TASTING = 'Tasting',
	COURSE = 'Course',
	WINEBOX = 'Wijnmixdoos',
}

// Move to top menu
// - Search
// - Contact
// -

export const LINKS = [
	{
		name: <GrapeIcon />,
		to: '/',
	},
	{ name: 'Wine Journal', to: '/wine-journal' },
	{ name: 'Study Notes', to: '/study-notes' },
	{ name: 'Courses', to: '/wijn-cursussen' },
	{ name: 'About', to: '/about' },
	{ name: 'For brands & professionals', to: '/wine-branding-consulting' },
	{ name: "Let's connect", to: '/connect-wine-strategist' },
	// { name: 'Shop', to: '/shop' },
	// { name: 'Proeverijen', to: '/wijn-proeverijen-castricum' },
	// { name: 'Wijnreizen', to: '/wijnreizen' },
	// { name: 'Over Margaret', to: '/over-margaret' },
	// { name: 'Karakterbox', to: '/karakterbox' },
	// { name: 'Sip & Read', to: '/sip-read-boeken-club' },

	// { name: 'Grape Charts', to: '/grape-charts' },
	// { name: 'Contact', to: '/contact' },
]

export const SECONDARY_LINKS = [
	// { name: 'Samenwerken', to: '/collab' },
	// { name: 'Study Blog', to: '/wset-study-blog' },
	{ name: 'Contact', to: '/contact' },
]

export const fallback = {
	metaTitle: 'Wine with Margaret',
	metaDescription: "@winewithmargaret's website",
}

export const SOCIALS = {
	instagram: 'https://www.instagram.com/winewithmargaret/',
	facebook: 'https://www.facebook.com/winewithmargaret/',
	email: 'mailto:growtogether@winewithmargaret.com',
	linkedin: 'https://www.linkedin.com/in/margot-van-lieshout/',
}

export const EMAILS = {
	margot: 'margot@winewithmargaret.com',
	growtogether: 'growtogether@winewithmargaret.com',
}
